var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "myReview" },
    [
      _c(
        "el-form",
        { ref: "searchForm", attrs: { inline: "" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "客户名称" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    remote: "",
                    "remote-method": _vm.getCompanyList,
                    clearable: "",
                    filterable: "",
                    placeholder: "请输入公司名称",
                  },
                  model: {
                    value: _vm.searchForm.customer_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "customer_id", $$v)
                    },
                    expression: "searchForm.customer_id",
                  },
                },
                _vm._l(_vm.companyList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.company_name + "（" + item.id + "）",
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.resetList },
                },
                [_vm._v("搜 索")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            border: "",
            "header-cell-style": { background: "#f1f1f1", color: "#333333" },
            align: "center",
            data: _vm.listData,
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "ID/状态", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.id))]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(scope.row.status_cn))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "客户名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(scope.row.customer_name) +
                          "(" +
                          _vm._s(scope.row.customer_id) +
                          ")"
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "需求类型", prop: "type_of_demand", width: "120" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "负责人", prop: "head", width: "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.head, function (value, index) {
                    return _c("div", { key: index }, [_vm._v(_vm._s(value))])
                  })
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "提交人/提交时间", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.create_name))]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(scope.row.created_at))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "处理人/处理时间", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.handler_name))]),
                    _vm._v(" "),
                    scope.row.create_name
                      ? _c("div", [_vm._v(_vm._s(scope.row.updated_at))])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "跟进记录", prop: "operation" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.operation && scope.row.operation.length > 9
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "tipBox",
                            attrs: {
                              "popper-class": "popperTipBox",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              _vm._l(
                                scope.row.operation,
                                function (value, index) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      _vm._s(value.created_at) +
                                        " " +
                                        _vm._s(value.operation_id) +
                                        " " +
                                        _vm._s(value.content)
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _vm._l(
                              scope.row.operation,
                              function (value, index) {
                                return _c("div", { key: index }, [
                                  _vm._v(
                                    _vm._s(value.created_at) +
                                      " " +
                                      _vm._s(value.operation_id) +
                                      " " +
                                      _vm._s(value.content)
                                  ),
                                ])
                              }
                            ),
                          ],
                          2
                        )
                      : _c(
                          "div",
                          _vm._l(scope.row.operation, function (value, index) {
                            return _c("div", { key: index }, [
                              _vm._v(
                                _vm._s(value.created_at) +
                                  " " +
                                  _vm._s(value.operation_id) +
                                  " " +
                                  _vm._s(value.content)
                              ),
                            ])
                          }),
                          0
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.approve(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("审批")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "pages",
          staticStyle: { "text-align": "right", margin: "16px 0" },
        },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.listPages.currentPage,
              "page-size": _vm.searchForm.pageSize,
              "page-sizes": [20, 50, 100, 200, 500],
              total: _vm.listPages.totalCount,
              layout: "total,sizes, prev, pager, next, jumper",
            },
            on: {
              "current-change": _vm.handlePageChange,
              "size-change": _vm.sizeChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.applyFormVisible,
            "destroy-on-close": true,
            "append-to-body": "",
            "custom-class": "myFormDrawer",
            size: "88%",
            title: "装修&项目交付申请",
          },
          on: {
            "update:visible": function ($event) {
              _vm.applyFormVisible = $event
            },
          },
        },
        [
          _c("applyForm", {
            attrs: {
              visible: _vm.applyFormVisible,
              type: _vm.applyFormType,
              id: _vm.selectedId,
            },
            on: {
              "update:visible": function ($event) {
                _vm.applyFormVisible = $event
              },
              close: _vm.handleClose,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }